import { render } from "./InputText.vue?vue&type=template&id=52a1e7f6&scoped=true&ts=true"
import script from "./InputText.vue?vue&type=script&lang=ts"
export * from "./InputText.vue?vue&type=script&lang=ts"

import "./InputText.vue?vue&type=style&index=0&id=52a1e7f6&lang=scss&scoped=true"

import exportComponent from "E:\\vue_test\\form-gpt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a1e7f6"]])

export default __exports__